import type { Resource } from '../../';
export const header_mobileMenu_trackPackage: Resource = {"default":"Track a Package"};
